export function parseCssUnit(unit: string | undefined): number {
	const units = ['px', 'rem', 'em'];

	if (!unit || !units.filter((u) => unit.indexOf(u) !== -1).length) {
		return 0;
	}

	let parsed = unit.replace(',', '.');
	units.forEach((u) => (parsed = parsed.replace(u, '')));

	return Number(parsed);
}
